import { render, staticRenderFns } from "./TableView.vue?vue&type=template&id=0428484a&scoped=true&"
import script from "./TableView.vue?vue&type=script&lang=js&"
export * from "./TableView.vue?vue&type=script&lang=js&"
import style0 from "./TableView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TableView.vue?vue&type=style&index=1&id=0428484a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0428484a",
  null
  
)

export default component.exports